/**
 * Which roles this account may assign (#443).
 *
 * THE BUG THIS REPLACES. Both clients did:
 *
 *     const availableRoles = theme === "Basic" ? BASIC_ROLES : ADVANCED_ROLES;
 *
 * and they were RIGHT to, in the sense that they mirrored the server:
 * account.py refused Editor and Limited whenever
 * get_current_theme(ctx.user_id)["theme"] was "Basic". The dropdown was
 * faithfully reflecting a rule that was wrong at the source.
 *
 * services/theme.py says why, in its own words:
 *
 *     theme is the PERSON's display preference -- their own row,
 *     always. Gating anything on it is what hid every business screen
 *     from a helper whose own tier set it to Basic (#443).
 *
 * So this is #443 one layer below the navigation. A helper on a Free
 * theme, acting as Admin on a fully entitled Business account, could not
 * assign an Editor -- because of THEIR display preference.
 *
 * THE RULE NOW is the account's TIER. A Free account keeps Admin and
 * Viewer, so nothing changes for a solo free user; a paid account may
 * assign all four, whoever is doing the assigning. PRICING_TIERS.md
 * differentiates team by SEAT COUNT (2 / 10 / unlimited) and never
 * mentions roles, so no priced boundary moved -- the same intent is
 * simply keyed to the right subject.
 *
 * `tier` must come from useFeatureTheme, NOT from useSubscription. The
 * former is the ACCOUNT's tier -- /user/theme resolves it through
 * ctx.account_user_id -- and the latter is the signed-in person's. Using
 * the person's here would reintroduce the exact bug with a different
 * field.
 */

export const ROLE_LABELS = {
  Admin: "Admin",
  Editor: "Editor",
  Contributor: "Contributor",
  Viewer: "Viewer",
  Limited: "Limited Editor",
};

/* What each role means, for the "?" beside the invite and team lists (#554).
   The labels above are short so all five fit on a phone; the detail lives
   here. Keep in step with RoleExplainer on web. */
export const ROLE_HELP = [
  ["Admin", "Everything an Editor can do, plus assign and delete team tasks and remove anyone's comments. Cannot invite people or touch billing."],
  ["Editor", "Add and edit hives, log inspections, record harvests, handle vendors and sales."],
  ["Contributor", "Records work (inspections, treatments, harvests, bottling, sales) but cannot add hives or vendors, or add, rename, retire or merge lists, sizes and varietals."],
  ["Limited Editor", "Like an Editor, but only at the sites they were given. Other sites do not appear."],
  ["Viewer", "Can look at everything but change nothing."],
];

const FREE_ROLES = ["Admin", "Viewer"];
const PAID_ROLES = ["Admin", "Editor", "Contributor", "Viewer", "Limited"];

export function rolesFor(tier, currentRole) {
  const roles = [...(tier === "Free" ? FREE_ROLES : PAID_ROLES)];

  /* NEVER HIDE THE ROLE SOMEBODY ALREADY HOLDS.
   *
   * The row's control is `value={r.role}` over this list, so a member
   * whose role is missing renders as a BLANK select -- the screen stops
   * saying what role they have, and the only way out is to pick one of
   * the roles on offer. An Editor on an account that has downgraded to
   * Free is exactly that case, and downgrades happen.
   *
   * Including it keeps the display honest and makes any change
   * deliberate: you can see what they are, and you can leave them
   * alone. The server still refuses to SET a role the tier disallows,
   * so this shows the truth without granting anything. */
  if (currentRole && !roles.includes(currentRole)) roles.push(currentRole);
  return roles;
}
